import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import axios from "axios";
import { API_URL } from '../../../../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';
import { shortMonthToFull, handleUserLevelAccessPermissions, validateRolesHapur, validateMonthYears } from '../../../../Custom/Custom'
import { ToastContainer, toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';
import WholeSalePriceForAgricultureItemsofHapurMandiData from '../../../../Components/WholeSalePriceForAgricultureItemsofHapurMandiData';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getYear, getMonth, getDay } from 'date-fns'
import moment from 'moment';
import messages from '../../../../assets/Messages.json'
import othersData from '../../../../others.json';


function WholeSalePriceForAgricultureItemsofHapurMandi() {


  const [districtList, setDistrictList] = useState([]);
  const [months, setMonth] = useState([]);
  const [districtCode, setDistrictCode] = useState('');
  const [yearName, setYearName] = useState('');
  const [monthName, setMonthName] = useState('');
  const [postDateFormat, setPostDateFormat] = useState('');
  const [hapurMandiItems, setHapurMandiItems] = useState([]);
  const [payload, setPayload] = useState([]);
  const [isDivision, setIsDivision] = useState(false);
  const [buttonAccess, setButtonAccess] = useState({ userLevel: '', roles: '', isVisible: false });
  const years = Array.from({ length: getYear(new Date()) - 2008 }, (_, index) => 2009 + index);
  const monthsList = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];
  const [calendarStartDate, setCalendarStartDate] = useState('');
  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token)
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const [isButtonDisabled, setButtonDisabled] = useState(false);

  const enableDisableBtn = () => {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
    if (checkboxes.length > 0) {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  };



  useEffect(() => {

    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level)

    // get District By Division ID
    const getDistrictListByDivision = async () => {
      try {
        const response = await axios.post(
          `${API_URL}api/geDistrictListByDivisionId`,
          { division_Id: decode_token.id.USER_LEVEL_LOCATION }, config);
        const allDistrict = response.data;

        if (allDistrict.status) {
          setDistrictList(allDistrict.data);
          showLoading(false);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    }



    // All district list
    const getDistrictList = async () => {

      try {
        const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
        const allDistrict = response.data;
        if (allDistrict.status) {
          let districtlist = "";



          if (level?.userLevel === 'HEAD QUARTER') {
            districtlist = allDistrict.data.filter(dist => dist.DISTRICT_CODE === '09')
          } else {
            districtlist = allDistrict.data;
          }
          setDistrictList(districtlist);
          showLoading(false);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    };

    //Get all Months data    
    const getMonthsList = (e) => {
      showLoading(true)
      axios
        .get(`${API_URL}api/graph/getMonths/2019`, config)
        .then((res) => {
          let monthDataResponse = res.data;
          if (monthDataResponse.status) {
            setMonth(monthDataResponse.data);
            showLoading(false)
          }
        })
        .catch((err) => {
          console.error(err);
          showLoading(false);
        });
    }


    const pageLoadHapurMandiItems = () => {
      showLoading(true);
      axios
        .get(`${API_URL}api/otherPrices/getWholeSalePriceForAgricultureItemsHapurMandiForm`, config)
        .then((res) => {

          const { data, success } = res.data;
          if (success) {
            setHapurMandiItems(data);
            setTimeout(() => (showLoading(false)), 3000)
          }
        }).catch((err) => {
          console.log(err)
          showLoading(false);
        });
    }

    const userRole = async () => {
      showLoading(true)
      try {
        const role = await validateRolesHapur(decode_token)
        if (role) {

          pageLoadHapurMandiItems();
          // SixtySevenNecessaryItemsInputFormDataUnitList();
          // getYearList();
          getMonthsList();

          if (level.userLevel === 'DIVISION LEVEL' && level.roles.includes('DIVADM')) {
            getDistrictListByDivision()
            setIsDivision(true)
          } else {
            getDistrictList()
          }


        } else {

          alert("You are not an authorized user to capture the data for Pricing");
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false)
      }
    }


    userRole();


  }, []);



  //Handle dropdown on chnage
  const handleDropdownChange = async (e) => {

    switch (e.target.name) {
      case 'district_name':
        setDistrictCode(e.target.value);
        if (monthName !== '' && yearName !== '' && postDateFormat !== '') {
          const formattedMonthValue = monthName < 10 ? `0${monthName}` : monthName;
          let postData = {
            "district_code": e.target.value,
            "month_name": formattedMonthValue,
            "year_name": yearName,
            "date_name": postDateFormat
          };
          onChangeGetAllHapurMandiData(postData);
        }
        break;
      case 'month_name':
        setMonthName(e.target.value);
        setCalendarStartDate('');
        setYearName('');
        setPostDateFormat('')

        break;
      case 'year_name':
        setYearName(e.target.value);
        break;

      default:
        console.log("switch case does not match");
        break;
    }


    if (e.target.name === 'startDateCalendar') {
      const inputDate = moment(new Date(e.target.name)).format("YYYY-MM-DD")
      setPostDateFormat(inputDate)
    }

  };


  //handle calender  on change   
  const handleDateChange = async (date) => {
    setCalendarStartDate(date)
    const inputDate = moment(new Date(date)).format("YYYY-MM-DD")
    setPostDateFormat(inputDate)
    const breakDate = inputDate.split('-')
    if (breakDate[1] < 10) {
      let mon = parseInt(breakDate[1], 10).toString();
      setMonthName(mon)
    }

    if (districtCode === '') {
      toast.error("Please Select District", messages.COLOR_RED);
    }

    setYearName(breakDate[0])

    if (districtCode && yearName !== '') {
      let postData = {
        "district_code": districtCode,
        "month_name": breakDate[1],
        "year_name": yearName,
        "date_name": inputDate,
      };
      onChangeGetAllHapurMandiData(postData);
    }
  }


  //Handle Get all on change Data
  const onChangeGetAllHapurMandiData = async (postData) => {
    showLoading(true);
    try {
      // Make API call to fetch data
      const response = await axios.post(`${API_URL}api/otherPrices/getWholeSalePriceForAgricultureItemsHapurMandiData`, postData, config);

      if (response.data.status) {
        setHapurMandiItems(response.data.data.GroupCodes);
        setPayload(response.data.data.payload);
        showLoading(false);
      }
    } catch (error) {
      console.error('Error posting data:', error);
      showLoading(false);
    }

  }

  //Handle reset Form Data
  const resetMothAndYearField = () => {
    setMonthName('')
    setYearName('')
    setDistrictCode('')
    setCalendarStartDate('')
    setPostDateFormat('')
  }



  const storedLanguage = localStorage.getItem('language');

  return (
    <>

      <ToastContainer />
      <GlobalLoading />
      <div className="container-fluid py-3">
        <div className='card_white mx-3 mb-3'>
          <div className="row align-items-center">
            <div className="col-12">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? titlesData.hi.WholeSalePriceForAgricultureItemsofHapurMandi : titlesData.en.WholeSalePriceForAgricultureItemsofHapurMandi }} />
              </h4>
            </div>
          </div>
          <div className="row align-items-center">
            {isDivision &&
              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION} </label>
                <input typr="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
              </div>
            }

            <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6 mb-3">
              <label>{storedLanguage === 'hi' ? othersData.hi.SELECT_DATE : othersData.en.SELECT_DATE}</label>
              <DatePicker
                className="form-control calendar_icon"
                dateFormat="yyyy-MM-dd"
                placeholderText="YY-MM-DD"
                renderCustomHeader={({
                  date,
                  changeYear,
                  changeMonth,
                  decreaseMonth,
                  increaseMonth,
                  prevMonthButtonDisabled,
                  nextMonthButtonDisabled,
                }) => (
                  <div
                    style={{
                      margin: 10,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                      {"<"}
                    </button>
                    <select
                      value={getYear(date)}
                      onChange={({ target: { value } }) => {
                        changeYear(value)
                        // setYearName(parseInt(value)); //set year in text box

                      }}
                    >
                      {years.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>

                    <select
                      value={monthsList[getMonth(date)]}
                      onChange={({ target: { value } }) => {
                        changeMonth(monthsList.indexOf(value))
                        // setMonthName(monthsList.indexOf(value)+1); //set year in dropDown
                      }
                      }
                    >

                      {monthsList.map((option, i) => (
                        <option key={i} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>

                    <button
                      onClick={increaseMonth} disabled={nextMonthButtonDisabled}
                    >
                      {">"}
                    </button>
                  </div>
                )}
                selected={calendarStartDate}
                onChange={(date) => {
                  const currentDate = new Date();
                  if (date > currentDate) {
                    toast.error('Invalid date', messages.COLOR_RED);
                    setMonthName('')
                    setYearName('')
                    setCalendarStartDate('')
                    return;
                  }
                  handleDateChange(date);
                }}
              />


            </div>

            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
              <label>{storedLanguage === 'hi' ? titlesData.hi.DISTRICT : titlesData.en.DISTRICT}</label>
              <select
                name="district_name"
                id="district_name"
                className="form-select"
                onChange={handleDropdownChange}
                value={districtCode}
              >
                <option value="" disabled>Select District</option>
                {districtList &&
                  districtList
                    .slice()
                    .sort((a, b) => a.DISTRICT_NAME.localeCompare(b.DISTRICT_NAME))
                    .map((ele, index) => (
                      <option key={index} value={ele.DISTRICT_CODE}>
                        {ele.DISTRICT_NAME}
                      </option>
                    ))}
              </select>
            </div>

            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
              <label>{storedLanguage === 'hi' ? titlesData.hi.MONTH : titlesData.en.MONTH}</label>
              <div className="d-flex align-items-center">
                <select
                  name="month_name"
                  id="month_name"
                  className="form-select"
                  onChange={handleDropdownChange}
                  value={monthName}
                >
                  <option value="" disabled>Select Month</option>
                  {months &&
                    months.map((ele, i) => {

                      return (
                        <option key={i + 1} value={i + 1}>
                          {shortMonthToFull(ele.MONTH)}
                        </option>
                      )
                    })}
                </select>

              </div>
            </div>



            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
              <label>{storedLanguage === 'hi' ? titlesData.hi.CURRENT_YEAR : titlesData.en.CURRENT_YEAR}</label>
              <input
                type="text"
                className="form-control"
                disabled
                value={yearName}
              />
            </div>

          </div>
        </div>

        <div className="card mx-3 mb-3 date_picket_z_index">



          {
            hapurMandiItems.length > 0 &&
            <WholeSalePriceForAgricultureItemsofHapurMandiData
              payload={payload}
              type="hapurMandi"
              config={config}
              resetMothAndYearField={resetMothAndYearField}
              userInfoObject={buttonAccess}
              yearName={yearName}
              monthName={monthName}
              hapurMandiItems={hapurMandiItems}
              dateName={postDateFormat}
              districtCode={districtCode}
              storedLanguage={storedLanguage}
              othersData={othersData}
              titlesData={titlesData}
            />
          }

        </div>
      </div>

    </>
  )
}

export default WholeSalePriceForAgricultureItemsofHapurMandi